/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Broken_Links_RelinkedInputs */



/**
* | output |
* | --- |
* | "Sources re-linked." |
*
* @param {Project_Broken_Links_RelinkedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_broken_links_relinked = /** @type {((inputs?: Project_Broken_Links_RelinkedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Broken_Links_RelinkedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellen neu verknüpft.")
	return /** @type {LocalizedString} */ ("Sources re-linked.")
});